export default "__VITE_ASSET__IsBuY9Nm__"